import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { ApplicantFormControllerService } from "../../../../../services/form-controller/applicant-form-controller.service";
import { ResizeEvent } from "angular-resizable-element";
import { IFormHistory } from "../../../../../models/form-history-interface";
import { BaseError } from "../../../base-error";

@Component({
  selector: "app-history-form",
  templateUrl: "./history-form.component.html",
  providers: [ApplicantFormControllerService],
})
export class HistoryFormComponent extends BaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public roleId: string;
  @Input() public historyController: IFormHistory;
  @Input() public hidePreview: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  public formHistory: any[];
  @Output() public closeLayer: EventEmitter<any> = new EventEmitter();
  @Output() public changeForm: EventEmitter<string> = new EventEmitter();
  public style: object = {};
  public dateFormat: string = "dd-MM-yyyy h:mm:ss a";

  public tryItem: any;
  public preview: boolean = false;
  public searchValue: string = "";
  public hideLoading: boolean = true;

  public usedId: string;

  public page: number = 0;
  public maxPage: number;

  public formSchema: any;

  public ngOnInit() {
    this.usedId = this.roleId ? this.roleId : this.serviceId;
    if (this.usedId) {
      this.loadFormHistory();
    }
  }

  public loadFormHistory() {
    this.historyController.getHistoryPage(this.usedId, this.page).subscribe(
      (data) => this.responseUpdate(data),
      (error) => this.showErrorMessage(error),
    );
  }

  public getPage(index): void {
    this.page = index;
    this.historyController.getHistoryPage(this.usedId, this.page).subscribe(
      (data) => this.responseUpdate(data),
      (error) => this.showErrorMessage(error),
    );

  }

  public getPages(): any[] {
    const min = this.page - 2 > 0 ? this.page - 2 : 0;
    const max = this.page + 2 <= this.maxPage ? this.page + 2 : (this.page + 1 <= this.maxPage ? this.page + 1 : this.page);
    const pages = [];
    for (let i = min; i <= max; i++) {
      pages.push(i);
    }
    return pages;
  }

  public responseUpdate(data) {
    this.maxPage = data.totalPages - 1;
    this.formHistory = data.publishList ? data.publishList : [];
    if (this.formHistory) {
      this.hideLoading = false;
    }
    this.cancelTry();
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSection() {
    this.closeLayer.emit();
  }

  public tryChangeForm(item: any): void {
    this.tryItem = item;
    this.preview = false;
  }

  public tryPreviewForm(item: any): void {
    // Use getFormSchemaForRevision for preview only (GET request)
    this.historyController.getFormSchemaForRevision(this.usedId, item.revisionNumber).subscribe((schema) => {
      if (schema) {
        this.tryItem = item;
        this.preview = true;
        this.formSchema = schema;
      }
    });
  }

  public cancelTry(): void {
    this.tryItem = null;
  }

  public cancelPreview(): void {
    this.tryItem = null;
    this.preview = false;
  }

  public onChangeForm(): void {
    this.preview = false;
    this.changeForm.emit(this.tryItem.revisionNumber);
    this.closeSection();
  }

}
